export const INSPECT_COLUMN_WIDTH = 280;

export const BUTTON_RESET = {
  display: 'inline-flex',
  alignItems: 'center',
  border: 'none',
  background: 'none',
  padding: 0,
  color: 'inherit',
  cursor: 'pointer',
};
